import React from "react";
import { ImageCacheProvider } from "../../../context/ImageCacheContext";
import SitelineFeed from "../components/SitelineFeed";
import "../styles/siteline.css";

const SitelinePage: React.FC = () => (
  <ImageCacheProvider>
    <div className="siteline-root">
      <SitelineFeed />
    </div>
  </ImageCacheProvider>
);

export default SitelinePage;
